/* eslint-disable camelcase */
import { Destination, SuggestItem } from '../../types';

const getCountry = (item: SuggestItem, locationCountValue: number): string => {
  switch (item.type) {
    case 'geo': {
      let country = '';

      if (locationCountValue > 1 && item.admin1code) {
        country = `${country}${item.admin1code}`;
        country = item.state ? `${country} (${item.state}), ` : `${country}, `;
      }

      if (item.country) {
        country = `${country}${item.country}`;
      }

      return country;
    }

    case 'airport':
    case 'tourism': {
      return item.country ? `${item.country}` : '';
    }

    case 'hotel': {
      let country = '';

      if (item.city_name) {
        country = `${item.city_name}, `;
      }

      if (item.country) {
        country = `${country}${item.country}`;
      }

      return country;
    }

    default: {
      return '';
    }
  }
};

const prepareSuggestItem = (
  suggestItem: SuggestItem,
  citiesLocationHash: Record<string, number>
): Destination => {
  const {
    id,
    type,
    name,
    country,
    country_code,
    timezone_gmt,
    lat,
    lng,
    country_slug,
    city_slug,
    city_name,
    city_id,
  } = suggestItem;
  const locationCountValue = citiesLocationHash[`${name}${country}${type}`];

  return {
    id,
    type,
    name,
    country: getCountry(suggestItem, locationCountValue),
    country_code,
    timezone_gmt,
    lat,
    lng,
    country_slug,
    city_slug,
    city_name,
    city_id,
  };
};

const prepareResponse = (suggestList: SuggestItem[]) => {
  if (!suggestList) {
    return suggestList;
  }

  const citiesLocationHash = suggestList.reduce((hash, suggestItem) => {
    const { type, name, country } = suggestItem;

    if (type === 'geo') {
      const cityLocationKey = `${name}${country}${type}`;
      // eslint-disable-next-line no-param-reassign
      hash[cityLocationKey] = (hash[cityLocationKey] || 0) + 1;
    }

    return hash;
  }, {} as Record<string, number>);

  return suggestList.map((suggestItem) => prepareSuggestItem(suggestItem, citiesLocationHash));
};

export default prepareResponse;
